import React from "react";
import { withRouter } from "react-router-dom";
import { Button as MuiButton } from "@material-ui/core";

import { withStyles } from "@material-ui/core/styles";
import { withNamespaces } from "react-i18next";

const styles = (theme) => ({
  buyTokenButton: {
    borderRadius: "20px",
    boxShadow: "0 1px 2px 0 rgba(0,0,0,.05)",
    backgroundColor: theme?.colors?.wallet?.buttonBackground,
    color: theme?.colors?.wallet?.buttonTextSecondary,
    textTransform: "capitalize",
    height: "40px",
    minWidth: "150px",
    padding: "8px 16px",
    "&:hover": {
      backgroundColor: theme?.colors?.wallet?.buttonBackgroundHover,
      color: theme?.colors?.wallet?.buttonTextSecondary,
    },
    "&:disabled": {
      opacity: "0.7",
      color: theme?.colors?.wallet?.buttonTextSecondary,
      cursor: "not-allowed",
    },
  },
  buttonLabel: {
    fontWeight: "bold",
    fontSize: "0.875rem",
    lineHeight: "1.25rem",
  },
});

const Button = ({ style, classes, text, onClick, disabled }) => {
  return (
    <MuiButton
      classes={{
        root: classes.buyTokenButton,
        label: classes.buttonLabel,
      }}
      style={style}
      onClick={onClick}
      disabled={disabled}
    >
      {text}
    </MuiButton>
  );
};

export default withNamespaces()(withRouter(withStyles(styles)(Button)));
